module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover1-14d055b04597452df90daa73a6800486.jpg";